export default __webpack_public_path__ + "static/media/plus_btn.1c8d84e2.svg";